export function removeHTMLTags(str) {
  if (str === null || str === "") return false;
  else str = str.toString();

  // Regular expression to identify HTML tags in the string
  return str.replace(/<p>/g, "");
}

export function removeHTMLFromCodeQuestion(str) {
  if (str === null || str === "") return "";
  str = str.toString();

  // Step 1: Replace <br> and <p> with newlines to preserve line breaks
  str = str.replace(/<br\s*\/?>|<\/p>/g, "\n").replace(/<p[^>]*>/g, "");

  // Remove other HTML tags
  str = str.replace(/<\/?[^>]+(>|$)/g, "");

  // Wrap text between ##code markers in <pre><code> tags
  str = str.replace(/##code([\s\S]*?)##code/g, "<pre><code>$1</code></pre>");

  return str;
}

export function removeTableAndMCQText(questionstr) {
  let simpleString = removeHTMLTags(questionstr?.split("##table")[0]?.split("##mcq")[0]);
  if (simpleString) {
    return simpleString.trim();
  } else {
    return "";
  }
}

export function ExtractTableData(str) {
  if (!str || typeof str !== "string") return { columnList: [], rowList: [] };

  const tableDataString = str.split("##table")[1];
  if (!tableDataString) return { columnList: [], rowList: [] };

  try {
    const tableData = JSON.parse(tableDataString.trim());
    return {
      columnList: tableData.columns || [],
      rowList: tableData.rows || [],
    };
  } catch (error) {
    return { columnList: [], rowList: [] };
  }
}
export function ExtractMCQData(str) {
  try {
    const mcqDataString = str.split("##mcq")[1];
    if (!mcqDataString) return "";

    const mcqData = JSON.parse(mcqDataString.trim());
    return {
      question: mcqData.question,
      options: mcqData.options,
      correct_option: mcqData.correct_option,
      correct_feedback: mcqData.correct_feedback,
      incorrect_feedback: mcqData.incorrect_feedback,
      selected_option: mcqData?.selected_option || "",
    };
  } catch (e) {
    return "";
  }
}

export default function extractQuestionText(questionstr) {
  let simpleString = removeHTMLTags(questionstr?.split("##table")[0].split("##code")[0].split("##mcq")[0]);
  if (simpleString) {
    return simpleString.trim();
  } else {
    return "";
  }
}
